import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { forumCommentsQueryOptions } from './useForumComments';
import { forumPostQueryOptions } from './useForumPost';
import { forumPostSystemMessagesQueryOptions } from './useForumPostSystemMessages';

export const useDeleteForumComment = (commentId: number, postId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return fetchJson(`/forum/comments/${commentId}`, {
        method: 'DELETE',
      });
    },
    onSuccess: () => {
      queryClient.setQueryData(forumCommentsQueryOptions(postId).queryKey, (comments) =>
        (comments ?? []).filter((comment) => comment.id !== commentId),
      );

      queryClient.invalidateQueries(forumCommentsQueryOptions(postId));
      queryClient.invalidateQueries(forumPostQueryOptions(postId));
      queryClient.invalidateQueries({ queryKey: QueryKeys.forum.index.root });

      return queryClient.invalidateQueries(forumPostSystemMessagesQueryOptions(postId));
    },
  });
};
